var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMan6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 419.003 419.003",
    style: {
      enableBackground: "new 0 0 419.003 419.003"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M333.774,355.973h-32.21v57.03h21.21h22v-46.03C344.774,360.894,339.844,355.973,333.774,355.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M344.774,419.003h-43.21c-3.313,0-6-2.686-6-6v-57.03c0-3.314,2.687-6,6-6h32.21 c9.374,0,17,7.626,17,17v46.03C350.774,416.317,348.087,419.003,344.774,419.003z M307.564,407.003h31.21v-40.03 c0-2.757-2.243-5-5-5h-26.21V407.003z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 128.934,
    cy: 145.999,
    r: 27.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 290.068,
    cy: 145.999,
    r: 27.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M128.934,179.889c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 c18.687,0,33.89,15.203,33.89,33.89S147.619,179.889,128.934,179.889z M128.934,124.109c-12.07,0-21.89,9.82-21.89,21.89 s9.819,21.89,21.89,21.89c12.071,0,21.89-9.82,21.89-21.89C150.822,133.929,141.003,124.109,128.934,124.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M290.068,179.889c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 c18.688,0,33.891,15.203,33.891,33.89S308.755,179.889,290.068,179.889z M290.068,124.109c-12.07,0-21.89,9.82-21.89,21.89 s9.819,21.89,21.89,21.89s21.891-9.82,21.891-21.89C311.958,133.929,302.138,124.109,290.068,124.109z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD14B"
    },
    d: "M258.856,241.969c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19v84.89h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M139.016,288.999v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C136.026,265.119,139.016,276.709,139.016,288.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M327.016,328.109v84.89h-47.04v-124c0-12.29,2.99-23.88,8.29-34.08 C311.656,270.839,327.016,297.689,327.016,328.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD14B"
    },
    d: "M327.016,328.109v19.89h-45.7h-1.34v-59c0-12.29,2.99-23.88,8.29-34.08 C311.656,270.839,327.016,297.689,327.016,328.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD14B"
    },
    d: "M139.016,288.999v59h-47.03v-19.89c0-30.42,15.35-57.27,38.74-73.19 C136.026,265.119,139.016,276.709,139.016,288.999z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.316,
    y: 341.999,
    style: {
      fill: "#333333"
    },
    width: 47.03,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M307.016,398.999c-3.313,0-6-2.686-6-6v-27c0-3.314,2.687-6,6-6s6,2.686,6,6v27 C313.016,396.313,310.329,398.999,307.016,398.999z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M135.667,266.919c-15.21,15.89-24.56,37.45-24.56,61.19 v19.89h-19.12v-19.89c0-30.42,15.35-57.27,38.74-73.19C132.706,258.739,134.366,262.749,135.667,266.919z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.053,
    y: 347.999,
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    width: 16.63,
    height: 65
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M327.016,418.999H91.986c-3.313,0-6-2.686-6-6v-84.89c0-31.306,15.463-60.521,41.364-78.15 c9.417-6.408,19.762-11.007,30.75-13.671c0.13-0.033,0.262-0.064,0.394-0.095l0.119-0.028l3.056,11.604 c-0.155,0.041-0.314,0.079-0.475,0.116l-0.119,0.028c-0.019,0.005-0.09,0.023-0.108,0.027c-9.596,2.321-18.635,6.338-26.864,11.938 c-22.615,15.392-36.116,40.899-36.116,68.23v78.891h223.03v-78.89c0-27.327-13.505-52.834-36.126-68.23 c-8.229-5.6-17.268-9.617-26.864-11.938c-0.041-0.01-0.082-0.02-0.122-0.031l-0.11-0.026c-0.155-0.036-0.311-0.073-0.463-0.113 l3.044-11.608l0.119,0.028c0.136,0.031,0.271,0.063,0.403,0.097c10.987,2.664,21.332,7.263,30.745,13.669 c25.907,17.633,41.374,46.848,41.374,78.15v84.892C333.016,416.313,330.329,418.999,327.016,418.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M145.016,412.999h-12v-124c0-11.054-2.562-21.59-7.614-31.314l10.648-5.533 c5.865,11.289,8.966,24.03,8.966,36.846V412.999z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.986,
    y: 341.999,
    style: {
      fill: "#333333"
    },
    width: 47.03,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M258.856,241.969c-14.1,9.49-31.08,15.03-49.36,15.03s-35.26-5.54-49.36-15.03 c-0.19-0.13-0.39-0.26-0.58-0.4c-23.28-15.94-38.56-42.72-38.56-73.07v-22.5v-51.5c0-48.877,39.623-88.5,88.5-88.5l0,0 c48.877,0,88.5,39.623,88.5,88.5v51.5v22.5c0,30.35-15.28,57.13-38.56,73.07C259.246,241.709,259.046,241.839,258.856,241.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M191.136,241.969c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07v-74c13.19,0,23.89,17.74,23.89,4.54l0,0c0-7.95,6.53-13.83,13.81-13.83 c1.81,0,3.68,0.37,5.5,1.16c4.58,1.98,9.26,3.65,14,5.01c-1.45,2.16-2.31,4.77-2.31,7.66v23.07c0,13.2-4.93,10.721-18.121,10.721 l-13.914,24.362c0,3.038,8.298,17.348,8.597,20.308c2.688,26.603,17.159,49.725,38.108,64.069 C190.746,241.709,190.947,241.839,191.136,241.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#665A52"
    },
    d: "M298,94.499v21.5c-29.39,17.4-66.73,13.38-91.74-9.87l-23.82-22.13c-7.89,18.21-25.85,30-45.7,30 H121v-19.5c0-48.88,39.62-88.5,88.5-88.5c24.44,0,46.56,9.9,62.58,25.92C288.09,47.939,298,70.059,298,94.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M226.66,7.663c-40.68,7.97-71.37,43.82-71.37,86.84v15.91 c-5.79,2.33-12.07,3.59-18.55,3.59H121v-19.5c0-48.88,39.62-88.5,88.5-88.5C215.37,6.004,221.11,6.574,226.66,7.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M259.436,242.109v17.89c0,27.58-22.36,49.94-49.94,49.94c-27.58,0-49.94-22.36-49.94-49.94v-17.89 c0.19-0.05,0.39-0.09,0.58-0.14c14.1,9.49,31.08,15.03,49.36,15.03s35.26-5.54,49.36-15.03 C259.046,242.019,259.246,242.059,259.436,242.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M257.876,242.619c-6.74,12.83-16.55,23.81-28.44,31.95 c-0.19,0.14-0.39,0.27-0.58,0.4c-14.1,9.49-31.08,15.03-49.36,15.03c-6.5,0-12.84-0.7-18.94-2.04c-0.66-3.23-1-6.57-1-9.99v-35.86 c0.19-0.05,0.39-0.09,0.58-0.14c14.1,9.49,31.08,15.03,49.36,15.03C227.356,256.999,243.977,251.709,257.876,242.619z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M243.122,34.835c16.565,9.373,28.862,25.444,33.184,44.509"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.301,85.345c-2.74,0-5.214-1.889-5.846-4.675c-3.88-17.115-14.92-31.918-30.288-40.613 c-2.884-1.632-3.898-5.293-2.267-8.177c1.631-2.884,5.293-3.899,8.177-2.268c18.304,10.357,31.455,27.999,36.081,48.404 c0.732,3.232-1.293,6.446-4.525,7.178C277.187,85.296,276.74,85.345,276.301,85.345z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M209.496,315.939c-30.846,0-55.94-25.094-55.94-55.94v-18.43h12v18.43 c0,24.229,19.712,43.94,43.94,43.94s43.939-19.711,43.939-43.94v-18.43h12v18.43C265.436,290.844,240.341,315.939,209.496,315.939z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M177.886,166.436c-1.58,0-3.13-0.64-4.24-1.75c-1.12-1.12-1.76-2.67-1.76-4.25s0.64-3.12,1.76-4.24 c1.39-1.39,3.46-2.03,5.41-1.64c0.39,0.08,0.76,0.19,1.13,0.34c0.36,0.15,0.71,0.34,1.03,0.55c0.33,0.22,0.64,0.47,0.91,0.75 c0.28,0.28,0.53,0.58,0.75,0.91s0.4,0.68,0.55,1.04s0.27,0.74,0.34,1.12c0.08,0.39,0.12,0.78,0.12,1.17s-0.04,0.79-0.12,1.18 c-0.07,0.38-0.19,0.76-0.34,1.12s-0.33,0.71-0.55,1.03c-0.22,0.33-0.47,0.64-0.75,0.92 C181.016,165.796,179.466,166.436,177.886,166.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M245.886,166.436c-0.39,0-0.79-0.04-1.17-0.11c-0.38-0.08-0.76-0.2-1.12-0.35 c-0.37-0.15-0.71-0.33-1.04-0.55s-0.64-0.47-0.91-0.74c-0.28-0.28-0.53-0.59-0.75-0.92c-0.22-0.32-0.4-0.67-0.55-1.03 s-0.27-0.74-0.34-1.12c-0.08-0.39-0.12-0.79-0.12-1.18s0.04-0.78,0.12-1.17c0.07-0.38,0.19-0.76,0.34-1.12s0.33-0.71,0.55-1.04 c0.22-0.33,0.47-0.63,0.75-0.91c0.27-0.28,0.58-0.53,0.91-0.75c0.33-0.21,0.67-0.4,1.04-0.55c0.36-0.15,0.74-0.26,1.12-0.34 c1.95-0.39,4.02,0.25,5.41,1.64c0.28,0.28,0.53,0.58,0.75,0.91s0.4,0.68,0.55,1.04s0.27,0.74,0.34,1.12 c0.08,0.39,0.12,0.78,0.12,1.17s-0.04,0.79-0.12,1.18c-0.07,0.38-0.19,0.76-0.34,1.12s-0.33,0.71-0.55,1.03 c-0.22,0.33-0.47,0.64-0.75,0.92C249.016,165.796,247.466,166.436,245.886,166.436z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M202.547,192.301c-3.118,0-5.752-2.411-5.979-5.57l-2.124-29.533 c-0.238-3.305,2.249-6.177,5.554-6.415c3.295-0.24,6.178,2.249,6.415,5.554l2.124,29.533c0.238,3.305-2.249,6.177-5.554,6.415 C202.837,192.295,202.692,192.301,202.547,192.301z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M216.052,222.634h-13.111c-3.313,0-6-2.686-6-6s2.687-6,6-6h13.111c3.313,0,6,2.686,6,6 S219.365,222.634,216.052,222.634z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M373.001,418.999h-11c-3.313,0-6-2.686-6-6s2.687-6,6-6h11c3.313,0,6,2.686,6,6 S376.315,418.999,373.001,418.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M57.001,418.999h-11c-3.313,0-6-2.686-6-6s2.687-6,6-6h11c3.313,0,6,2.686,6,6 S60.315,418.999,57.001,418.999z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 172.141,
    cy: 157.192,
    r: 28.289
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 246.852,
    cy: 157.192,
    r: 28.289
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M218.563,162.767h-18.134c-3.313,0-6-2.686-6-6s2.687-6,6-6h18.134c3.313,0,6,2.686,6,6 S221.876,162.767,218.563,162.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M275.141,162.767c-1.553,0-3.104-0.599-4.279-1.794c-2.322-2.364-2.29-6.162,0.073-8.485 l22.859-22.467c2.364-2.322,6.162-2.291,8.485,0.073c2.322,2.364,2.29,6.162-0.073,8.485l-22.859,22.467 C278.178,162.194,276.659,162.767,275.141,162.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M143.852,162.767c-1.519,0-3.037-0.573-4.206-1.721l-22.86-22.467 c-2.363-2.323-2.396-6.122-0.073-8.485c2.323-2.364,6.121-2.396,8.485-0.074l22.86,22.467c2.363,2.323,2.396,6.122,0.073,8.485 C146.956,162.167,145.405,162.767,143.852,162.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M209.5,262.999c-18.88,0-37.106-5.551-52.71-16.052l-0.175-0.118 c-0.173-0.117-0.348-0.236-0.519-0.359C130.363,228.814,115,199.672,115,168.5v-74C115,42.393,157.393,0,209.5,0 c25.243,0,48.975,9.829,66.823,27.677c17.848,17.86,27.677,41.591,27.677,66.823v74c0,31.176-15.362,60.318-41.102,77.974 c-0.168,0.121-0.34,0.238-0.511,0.353l-0.135,0.092C246.607,257.448,228.38,262.999,209.5,262.999z M209.5,11.999 c-45.49,0-82.5,37.009-82.5,82.5v74c0,27.241,13.439,52.706,35.95,68.119c0.059,0.04,0.117,0.082,0.175,0.124l0.407,0.278 c13.574,9.135,29.484,13.979,45.968,13.979s32.395-4.844,46.011-14.008l0.167-0.114c0.07-0.047,0.142-0.094,0.211-0.144 c0.053-0.039,0.107-0.078,0.162-0.115C278.561,221.205,292,195.739,292,168.499v-74c0-22.028-8.582-42.746-24.164-58.339 C252.257,20.58,231.538,11.999,209.5,11.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M258.886,132.76c-3.001,0-6.016-0.162-9.04-0.487c-17.959-1.933-34.443-9.454-47.671-21.75 l-18.079-16.797c-10.083,16.187-27.894,26.273-47.356,26.273H121v-12h15.74c17.472,0,33.249-10.357,40.194-26.385 c0.774-1.787,2.368-3.087,4.274-3.487c1.909-0.4,3.889,0.151,5.315,1.477l23.819,22.13c22.902,21.291,57.689,25.033,84.6,9.103 l6.113,10.326C288.132,128.814,273.706,132.76,258.886,132.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M258.77,366.974v46.03h-22v-46.03c0-6.08,4.93-11,11-11 C253.85,355.974,258.77,360.894,258.77,366.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M279.98,355.974v57.03h-21.21v-46.03c0-6.08-4.92-11-11-11H279.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M285.981,413.003h-12v-124c0-12.818,3.101-25.56,8.966-36.847l10.648,5.534 c-5.053,9.722-7.614,20.257-7.614,31.313V413.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M341,419.003h-82.229c-3.313,0-6-2.686-6-6s2.687-6,6-6H341c3.313,0,6,2.686,6,6 S344.314,419.003,341,419.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M236.771,419.003H78.231c-3.313,0-6-2.686-6-6s2.687-6,6-6h158.54c3.313,0,6,2.686,6,6 S240.085,419.003,236.771,419.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M258.771,419.003h-22c-3.313,0-6-2.686-6-6v-46.03c0-9.374,7.626-17,17-17s17,7.626,17,17v46.03 C264.771,416.317,262.084,419.003,258.771,419.003z M242.771,407.003h10v-40.03c0-2.757-2.243-5-5-5c-2.757,0-5,2.243-5,5V407.003z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.771,
    y: 349.973,
    style: {
      fill: "#333333"
    },
    width: 32.21,
    height: 12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M172.141,191.481c-18.907,0-34.289-15.382-34.289-34.289s15.382-34.289,34.289-34.289 c18.906,0,34.288,15.382,34.288,34.289S191.047,191.481,172.141,191.481z M172.141,134.903c-12.29,0-22.289,9.999-22.289,22.289 c0,12.29,9.999,22.289,22.289,22.289s22.288-9.999,22.288-22.289S184.431,134.903,172.141,134.903z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M172.141,142.903c7.879,0,14.289,6.41,14.289,14.289"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.43,163.192c-3.313,0-6-2.686-6-6c0-4.571-3.719-8.289-8.289-8.289c-3.313,0-6-2.686-6-6 s2.687-6,6-6c11.188,0,20.289,9.102,20.289,20.289C192.43,160.506,189.743,163.192,186.43,163.192z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M246.852,191.481c-18.907,0-34.289-15.382-34.289-34.289s15.382-34.289,34.289-34.289 c18.907,0,34.289,15.382,34.289,34.289S265.759,191.481,246.852,191.481z M246.852,134.903c-12.29,0-22.289,9.999-22.289,22.289 c0,12.29,9.999,22.289,22.289,22.289s22.289-9.999,22.289-22.289S259.142,134.903,246.852,134.903z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M246.852,142.903c7.879,0,14.289,6.41,14.289,14.289"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.141,163.192c-3.313,0-6-2.686-6-6c0-4.571-3.719-8.289-8.289-8.289c-3.313,0-6-2.686-6-6 s2.687-6,6-6c11.188,0,20.289,9.102,20.289,20.289C267.141,160.506,264.454,163.192,261.141,163.192z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan6);
export default __webpack_public_path__ + "static/media/man6.df8579a75aeda39dd7f5048812acfb66.svg";
export { ForwardRef as ReactComponent };